export default __webpack_public_path__ + "static/media/GA_LOGOTIPO2_BLANCO.fc58ceed.png";